module.exports = __webpack_public_path__ + "assets/img/free_16.f764013e.png";